/* eslint-disable no-console */
/**
 * Client logger
 */
import LOG_LEVELS from '../types/LogLevels';
import { LOG_LEVEL as configLevel } from './config';

/**
 *
 * @param message
 * @param level
 */
const logMessage = (message: any, level: LOG_LEVELS = LOG_LEVELS.INFO) => {
  if (level === LOG_LEVELS.OFF) {
    throw new Error('Check your setup - a log level of OFF is odd here.');
  }

  if (configLevel !== LOG_LEVELS.OFF && level <= configLevel) {
    switch (level) {
      case LOG_LEVELS.ERROR:
        console.error(...message);
        break;
      case LOG_LEVELS.WARN:
        console.warn(...message);
        break;
      case LOG_LEVELS.INFO:
        console.info(...message);
        break;
      case LOG_LEVELS.DEBUG:
        console.debug(...message);
        break;
      case LOG_LEVELS.TRACE:
        console.trace(...message);
        break;
      default:
        console.warn('Unrecognized log level', level);
        console.log(...message);
    }
  }
};

export default {
  trace: (...message: any) => logMessage(message, LOG_LEVELS.TRACE),
  debug: (...message: any) => logMessage(message, LOG_LEVELS.DEBUG),
  log: (...message: any) => logMessage(message, LOG_LEVELS.INFO),
  info: (...message: any) => logMessage(message, LOG_LEVELS.INFO),
  warn: (...message: any) => logMessage(message, LOG_LEVELS.WARN),
  error: (...message: any) => logMessage(message, LOG_LEVELS.ERROR),
};
